<template>
  <div>
    <head-view></head-view>
    <div class="main-bg-wrapper"><!-- 给 MainPageBG14.png 包一层 main-bg-wrapper，让 TapTapDownLoad.png 可以 absolute 定位,才能将图片覆盖在此图片上面。 -->
    <!-- 背景图 -->
      <img src="@/assets/img/02MKQY/1920x1080-logo.png" alt="" class="main-bg"><!-- 背景图 -->

      <div class="download-buttons">
      <!-- TapTap 下载按钮 -->
      <a href="https://l.taptap.cn/ePkeN2oc?channel=rep-rep_kzlosm4icdx" target="_blank" rel="noopener noreferrer"><!--<router-link> 是 Vue Router 的组件只用来跳转 项目内的路由（比如 /home、/about），不会处理外部网址 <router-link to="https://www.taptap.cn/"> </router-link>-->
        <img src="@/assets/img/TapTapDownLoad.png" alt="" class="tap-icon" ><!-- TapTapDownLoad -->
      </a>

      <!-- iOS 下载按钮 -->
      <a href="https://apps.apple.com/cn/app/id6757304230" target="_blank" rel="noopener noreferrer"><!--<router-link> 是 Vue Router 的组件只用来跳转 项目内的路由（比如 /home、/about），不会处理外部网址 <router-link to="https://www.taptap.cn/"> </router-link>-->
        <img src="@/assets/img/IOSDownLoad.png" alt="iOS下载" class="ios-icon">
      </a>
      </div>
    </div>
    

    <div class="img-row">
      <!-- <img src="@/assets/img/MHLH/icon.jpg" alt="" class="icon-img"> -->
      <img src="@/assets/img/02MKQY/1.jpg" alt="">
      <img src="@/assets/img/02MKQY/2.jpg" alt="">
      <img src="@/assets/img/02MKQY/3.jpg" alt="">
      <img src="@/assets/img/02MKQY/4.jpg" alt="">
      <img src="@/assets/img/02MKQY/5.jpg" alt="">
    </div>
    <footer-view></footer-view><!-- 底部隐私协议等 -->
</div>
</template>
<script>
import headView from '../header/headView.vue'
import FooterView from '../footer/footerView.vue';
export default {
  components: { headView,FooterView },
}

</script>

<style scoped>
head-view {
  display: block;       /* 确保是块级元素 */
  position: relative;   /* 避免 absolute 脱离文档流 */
  z-index: 1;           /* 保证在图片上方或下方可控 */
}
.main-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;          /* ✅ 横向铺满 */
  object-position: center;    /* ✅ 裁剪时以中心为准 */
  object-position: center 5%; /* 👈 往上移一点 */
  display: block;
}
.main-bg-wrapper {
  position: relative;
  width: 100%;
  height: 60vh;        /* 屏幕 1/3 */
  margin-top: 100px;
  overflow: hidden;
}

.tap-icon {
  position: absolute;
  bottom: 15%;;        /* 距离底部 */
  left: 20%;          /* 距离左边 */
  width: 10%;        /* 控制大小 ,跟随屏幕等比缩放都要用%,不然图片对比其他参照会缩放过大 */
  height: auto;
  z-index: 2;

  transition: transform 0.3s ease;
  transform-origin: center center; /* 放大基准点在自身中心 */
  
}
.tap-icon:hover {
  transform: scale(1.2); /* 悬停原地放大 */
}

/* iOS 按钮，放在 TapTap 的右边 */
.ios-icon {
  position: absolute;
  bottom: 15%;;
  left: 32%;   /* 调整位置，保证在 TapTap 的右边 */
  width: 10%;
  height: auto;
  z-index: 2;
  transition: transform 0.3s ease;
  transform-origin: center center;
}
.ios-icon:hover {
  transform: scale(1.2);
}


.img-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 10px;  /* 根据 head-view 的高度调整 */
  margin-bottom: 10px; /* 和 footer 保持 10px 间隔 */
}

.img-row img {
  width: calc((100% - 40px) / 5); /* 5 张图一行，4 个间距10px */
  height: auto;
  object-fit: contain;
}

@media (max-width: 768px) {
  .img-row img {
    width: calc((100% - 20px) / 2); /* 屏幕小于768px时，每行2张 */
  }
}

@media (max-width: 480px) {
  .img-row img {
    width: 100%;                     /* 屏幕小于480px时，每行1张 */
  }
}


</style>